import { PersonSummary } from '../../../components/avatar';

const ROLE_LABELS = {
    profesor: 'Profesor',
    moderador: 'Moderador',
    estudiante: 'Estudiante',
};

const formatRole = (user) => {
    const key = user.participantRole || user.typeUser;
    return ROLE_LABELS[key] || key || '';
};

export const OnlineUsers = ({ participants = [], currentUserId }) => {
    const onlineCount = participants.filter((p) => p.isOnline).length;

    return (
        <div className="chat-online">
            <p className="chat-online__head">
                {onlineCount} en línea · {participants.length} en el curso
            </p>
            <div className="chat-online__list course-tab-stagger">
                {participants.length === 0 ? (
                    <p className="chat-online__empty">Sin participantes</p>
                ) : (
                    participants.map((user) => {
                        const userId = user._id?.toString?.() || user._id;
                        const selfId = currentUserId?.toString?.() || currentUserId;
                        const isSelf = userId === selfId;
                        const isOnline = Boolean(user.isOnline);

                        return (
                            <div
                                key={user._id}
                                className="chat-online__user"
                            >
                                <PersonSummary
                                    firstName={user.firstName}
                                    lastName={user.lastName}
                                    role={formatRole(user)}
                                    meta={user.email}
                                    youBadge={isSelf ? '(Tú)' : undefined}
                                    avatarSize="md"
                                    status={isOnline ? 'online' : 'offline'}
                                    statusLabel={isOnline ? 'En línea' : 'Desconectado'}
                                    className="chat-online__person"
                                />
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};
